<template>
  <Modal 
    :id="'cmp-add-prices'"
    @cancelled="onCancel"
  >
    
    <template slot="header"></template>

    <template slot="body">
        <div  style="height:200px">
            <NTable
                class="dbox1"
                id="distribution-order-sidewindow-backorder"
                :config="tableConfig"
                :headers="headers"
                :items="priceCodeList"            
            >
            <template v-slot:item="{ item, tdcon }">
                <tr
                   
                >
                    <td   v-bind="tdcon('price_code')">
                        <span>{{item['price_code_name']}}</span>
                    </td>
                  
                    <td   v-bind="tdcon('discount')">
                      <TextField2
                        type="text"
                        class="dbox1"
                        id="discount"
                        :showLabel="false"
                        :disabled="false"
                        :value="getQtyValue(item,'discount')"
                        :bb="'0px'"
                        :ta="'right'" 
                        @change="(e) => onTextFieldChange(e, item)"
                      />
                    </td>
               
             
                
                    
                </tr>
            </template>
            </NTable>
      </div>


    </template>

    <template slot="options">
        <button class="dt-button s6" @click="onCancel">{{$t('cancel')}}</button>
        <button class="dt-button v1 s6" @click="onOKClick">{{$t('ok')}}</button>
        
    
 
      
    </template>

  </Modal>
</template>

<script>


import InputField from "@/plugins/text-field/input-field";
import NTable from "@/plugins/datatable/datatable";
import { createNTableConfig, createTableHeader } from "@/plugins/datatable";

import Modal from '../../../../dt-plugins/modal/modal';

import { OrderService } from '../../services/order.service';




export default {
  props: {


  },
  components: {
    InputField,
    NTable,
    Modal
  },
  mixins: [
 
  ],
  data: function() {
    return {
      priceCodeList: [],
      discountToApply:[],
  
        
      tableConfig: createNTableConfig({
        headerStyle: 3,
        fullHeight:true
      }),
      
      
    
     

    
    
    };
  },
  mounted:async function() {
    const pricedata=await OrderService.priceCodeDiscountModal(this.order_id);
    this.priceCodeList=pricedata.data.price_codes
    console.log("::::DATA::::",pricedata)

  },
  computed: {
    headers: function () {
      return [
        createTableHeader("price_code",{ text:"Price Code"}),
        createTableHeader("discount"),
      
      ]
     
    },
    
    hRowMarginRight: function() {
      if (this.priceCodeList.length > 380 / 28) {
        return "28px";
      }
    },
  
    order_id: function() {
      return this.$route.query.order_id;
    },


  },
  methods: {
      getQtyValue:function(item,name){
      const discount= this.discountToApply.find(e=>e.price_code_id==item.price_code_id);
      if(discount && discount[name]!=0){
       console.log("PRODUCT:::",discount) 
       return discount[name];
      }
    },
    onTextFieldChange:function(e,item){
      const { name ,value}=e;

      
      const discount= this.discountToApply.find(e=>e.price_code_id==item.price_code_id)
      
      if(!discount){
        this.discountToApply=[{ price_code_id:item.price_code_id,discount:value}];
      }

      
  

      this.discountToApply=this.discountToApply.map(e=>{
        if(e.price_code_id==item.price_code_id){
          return{
            ...e,
            [name]:value
          }
        }else{
          return e;
        }
      })
      
    },
    onCancel: function() {
  
      this.$emit("cancelled", true);
    },
    

    onOKClick: function() {
      const payload={ price_codes:this.discountToApply ,order_id:this.order_id} 
       this.$emit("update",payload)
    }
  }
};


</script>

<style lang="scss" scoped>
.dt-modal--body {
  margin-left: 0px;
}

.contact-search {
  height: 30px;
  width: 290px;
}

.contact-table {
  margin-top: 10px;

  tbody {
    min-height: 380px;
  }
}

.dt-table2 {
  --body-height: 380px;
  --row-height: 28px;

  display: flex;
  flex-direction: column;

  &--head {
  }
  th.dt-table2--column {
    text-align: left;
    color: #828282;
    font-weight: 400;
  }
  &--body {
    background: #f8f8f8;

    display: flex;
    flex-direction: column;

    border: 1px solid var(--sprt-5);
    border-radius: 3px;

    .dt-table2--row {
      border-bottom: 1px solid var(--sprt-7);
    }

    max-height: var(--body-height);
    overflow: auto;
  }
  &--row {
    display: flex;
    flex-direction: row;
    padding: 5px;
    margin: 0px 10px;

    min-height: var(--row-height);
    cursor: pointer;

    &:hover {
      //background: rgb(235, 235, 235);
    }
  }
  &--column {
    flex: 1;

    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.dt-modal--options {

  button{
      &:first-child {
          margin-right: 10px;
      }
      &:last-child {
          margin-left:0px 10px;
      }
  }
}
</style>